import axios from "axios";
import apiUrlOne from "../Config";

// Create timeslot
export const createTimeslot = async (formData) => {
    const response = await axios.post(`${apiUrlOne}/timeslots/create-timeslot`, formData, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
};

// Update timeslot
export const updateTimeslot = async (id, formData) => {
    const response = await axios.put(`${apiUrlOne}/timeslots/update-timeslot/${id}`, formData, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
};

// Delete timeslot
export const deleteTimeslot = async (id) => {
    if (!id) throw new Error("Timeslot ID is required for deletion");

    try {
        const response = await axios.delete(`${apiUrlOne}/timeslots/delete-timeslot/${id}`);
        // Optionally log response for debugging
        console.log("DeleteTimeslot Response:", response.data);
        return response.data;
    } catch (error) {
        console.error("DeleteTimeslot Error:", error.response?.data || error.message);
        throw error;
    }
};

// Get all timeslots for admin
export const getAllTimeslotsAdmin = async () => {
    const response = await axios.get(`${apiUrlOne}/timeslots/getalltimeslot-admin`);
    return response.data;
};

// Get timeslot by ID (search from all since no endpoint)
export const getTimeslotById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/timeslots/get-timeslot/${id}`);
        return response.data; // assuming API returns { data: { ...timeslot } }
    } catch (error) {
        console.error("Error fetching timeslot:", error);
        throw error;
    }
};

